module.exports = __webpack_public_path__ + "img/person.a4afb118.jpeg";